import React from 'react';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import * as Styled from '../LoyaltyPageReport.styles';
import Button from '../../../components/Button';
import CustomToggle from '../../../components/CustomToggle';
import { formatTime } from '../../../global/helpers';
import { ReportType } from '../types';
import { selectors } from '../../LoyaltyPage/reducer';

interface PeriodPickerPanelProps {
  startDate: Date | null;
  endDate: Date | null;
  onStartChange: (date: Date | null) => void;
  onEndChange: (date: Date | null) => void;
  showActions: boolean;
  errorVisible: boolean;
  onGenerate: () => void;
  reportType: ReportType | null;
  onReportTypeChange: (type: ReportType) => void;
}

const formattedStartDate = (startDate: Date | null) =>
  startDate ? formatTime(startDate.toISOString()) : '';
const formattedEndDate = (endDate: Date | null) =>
  endDate ? formatTime(endDate.toISOString()) : '';

const PeriodPickerPanel = ({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  showActions,
  errorVisible,
  onGenerate,
  reportType,
  onReportTypeChange,
}: PeriodPickerPanelProps) => {
  const { t } = useTranslation();

  const loyaltyPdfLoading = useSelector(selectors.loyaltyPdfLoading);

  return (
    <Styled.PickersContainer>
      <Styled.Picker>
        <div className="label">{t('ReportPage.START_DATE_LABEL')}</div>
        <div className="day">{formattedStartDate(startDate)}</div>
        <DatePicker
          locale="ru"
          selected={startDate}
          onChange={(date: Date | null) => onStartChange(date)}
          timeInputLabel="Время:"
          dateFormat="MM/dd/yyyy HH:mm"
          showTimeInput
          inline
        />
      </Styled.Picker>
      <Styled.Picker>
        <div className="label">{t('ReportPage.END_DATE_LABEL')}</div>
        <div className="day">{formattedEndDate(endDate)}</div>
        <DatePicker
          locale="ru"
          selected={endDate}
          onChange={(date: Date | null) => onEndChange(date)}
          timeInputLabel="Время:"
          dateFormat="MM/dd/yyyy HH:mm"
          showTimeInput
          inline
        />
      </Styled.Picker>
      {showActions && (
        <Styled.GenerateButton>
          {errorVisible && (
            <div className="error-tooltip">{t('ReportPage.ERROR_TOOLTIP')}</div>
          )}
          <Button
            text={t('ReportPage.GENERATE_INVOICE_BTN')}
            onClick={onGenerate}
            isLoading={loyaltyPdfLoading}
            disabled={loyaltyPdfLoading}
          />
          <Styled.TogglesBlock>
            <CustomToggle
              onChange={(e: boolean) => onReportTypeChange(e ? 'xlsx' : 'pdf')}
              id="reportType"
              checked={reportType === 'xlsx'}
              variant="standart"
              title=".xlsx"
            />
          </Styled.TogglesBlock>
        </Styled.GenerateButton>
      )}
    </Styled.PickersContainer>
  );
};

export default PeriodPickerPanel;
